import {HIDE_FIRST_NAME} from 'src/pages/localChannelLineup/store/actions/hideFirstName';

export const showFirstName = (state = true, {type} = {}) => {
  switch (type) {
    case HIDE_FIRST_NAME:
      return false;
    default:
      return state;
  }
};
